import axios from './base'

// 权益券种管理 API（后端 tb_benefit，路由 /benefit）
// 发放方式只有「每月发放 / 里程碑发放」两种固定规则（程序结构，不进字典）：券种 dispatch_ids 存标识串 monthly/milestone
// 里程碑的「达成条件」是运营可增删的业务枚举，走 mg_dict 的 dispatch_milestone（券种存其 _id）
// 中文文案由前端映射；所有券都可手动指定发放

// 券种列表（keyword/category/dispatch/status 筛选 + 服务端分页；响应带 status_counts / total_received）
// dispatch：manual = 仅手动发放（未配置自动发放）；monthly / milestone = 启用了该发放方式
export function getBenefitList(params = {}) {
  return axios.request({
    url: `/benefit`,
    method: 'get',
    params,
  })
}

// 券种详情（编辑回显）
export function getBenefitDetail(id) {
  return axios.request({
    url: `/benefit/${id}`,
    method: 'get',
  })
}

// 新增券种
export function createBenefit(data = {}) {
  return axios.request({
    url: `/benefit`,
    method: 'post',
    data,
  })
}

// 编辑券种
export function updateBenefit(id, data = {}) {
  return axios.request({
    url: `/benefit/${id}`,
    method: 'put',
    data,
  })
}

// 删除券种（软删）
export function deleteBenefit(id) {
  return axios.request({
    url: `/benefit/${id}`,
    method: 'delete',
  })
}

// 启用 / 停用（data: { status: 1 启用 / 0 停用 }）
export function setBenefitStatus(id, data = {}) {
  return axios.request({
    url: `/benefit/${id}/status`,
    method: 'put',
    data,
  })
}

// 券种下拉（默认只返回启用中的券种，返回 [{ id, name, total, received_count }]）
// 传 { all: 1 } 返回全部未删除券种（含已停用），供持券记录等历史数据筛选
export function getBenefitOptions(params = {}) {
  return axios.request({
    url: `/benefit/options`,
    method: 'get',
    params,
  })
}

// 指定发放（data: { benefit_id, user_ids: [], num, remark }；响应 { count, failed }）
export function grantBenefit(data = {}) {
  return axios.request({
    url: `/benefit/grant`,
    method: 'post',
    data,
  })
}

// 持券记录列表（keyword/benefit_id/status/date_range 筛选 + 服务端分页；响应带 status_counts）
// 核销码由后端统一脱敏，完整码只在详情、且需权限
export function getUserBenefitList(params = {}) {
  return axios.request({
    url: `/benefit/user`,
    method: 'get',
    params,
  })
}

// 持券详情（无权限时只返脱敏码，verify_code_full 为空串）
export function getUserBenefitDetail(id) {
  return axios.request({
    url: `/benefit/user/${id}`,
    method: 'get',
  })
}

// ==================== 核销 ====================

// 核销记录列表（keyword=核销码/昵称/券名、result 1成功0失败、date_range 核销时间区间 + 服务端分页；响应带 result_counts）
// 核销码返原始输入快照（不脱敏），失败记录的码可能不存在
export function getVerifyLogList(params = {}) {
  return axios.request({
    url: `/benefit/verify`,
    method: 'get',
    params,
  })
}

// 今日核销统计（券码核销页头部，返回 { success, fail }）
export function getVerifyTodayStats() {
  return axios.request({
    url: `/benefit/verify/today-stats`,
    method: 'get',
  })
}

// 核销（data: { code }；响应 { result, fail_reason, record, target }，失败也走 code=200）
export function checkinVerify(data = {}) {
  return axios.request({
    url: `/benefit/checkin/verify`,
    method: 'post',
    data,
  })
}

// 作废（data: { code }；响应 { result, message, target }，result=0 时 message 为不可作废的原因）
export function checkinVoid(data = {}) {
  return axios.request({
    url: `/benefit/checkin/void`,
    method: 'post',
    data,
  })
}
